import { IconName } from '../components/ui/Icon';

/**
 * The notification feed.
 *
 * `when` is pre-formatted rather than a timestamp - nothing here does
 * relative-time arithmetic, and a real feed would send the string it wants
 * shown anyway. Note `NotificationsScreen.bucketOf` day-groups by matching
 * that string, so a feed sending "2 days ago" lands under "Today"; give it
 * real timestamps before relying on the grouping.
 */

export type NotificationKind = 'booking' | 'offer' | 'reminder' | 'account';

export type AppNotification = {
  id: string;
  kind: NotificationKind;
  title: string;
  body: string;
  when: string;
  read: boolean;
  /** The booking this is about, when it is about one - tapping opens it. */
  bookingId?: string;
};

/** Each kind carries its own mark, so the list scans without reading. */
export const notificationIcon: Record<NotificationKind, IconName> = {
  booking: 'calendar',
  offer: 'star',
  reminder: 'clock',
  account: 'user',
};

/**
 * The feed at startup: EMPTY until the platform's inbox answers
 * (`services/notifications.ts`, loaded by `HomeScreen` once signed in).
 *
 * Five invented notifications lived here - "Ravi is on the way", "20% off deep
 * cleaning", "Rate your plumber" and two more - and they were shown to every
 * account including signed-out ones. They named a professional nobody booked,
 * advertised an offer that does not exist, and asked for a review of a job
 * that never happened.
 *
 * Marking them read was local-only too, so they came back unread on every
 * restart. Reads now go to the server as well.
 */
export const initialNotifications: AppNotification[] = [];
